"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useEffectDataLayerGA4ViewItem;

var _react = _interopRequireDefault(require("react"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useMulticurrencyToPrice = _interopRequireDefault(require("@sprinx/react-globalize/useMulticurrencyToPrice"));

var _index = _interopRequireDefault(require("../shop/useShoppingCurrency/index"));

function useEffectDataLayerGA4ViewItem(product) {
  var t = (0, _useTranslate.default)();
  var currency = (0, _index.default)();
  var getPrice = (0, _useMulticurrencyToPrice.default)(null, currency);

  _react.default.useEffect(function () {
    var salePrice = getPrice(product.salePrice || []);

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        ecommerce: null
      });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: currency.split('-')[0],
          value: salePrice,
          items: {
            item_id: product.id,
            item_name: t(product.name),
            affiliation: 'Online store',
            price: salePrice
          }
        }
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
}